/**
 * LandingPage - The main landing page for the application.
 * This page introduces the DEEBug website and encourage users
 * toward trying the demo through Projects.
 * @returns The rendered landing page layout.
 */

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import codebaseService from "../services/codebaseService";

const LandingPage = () => {
  const [recentProjects, setRecentProjects] = useState([]);
  const navigate = useNavigate();

  const EditCodebase = (codebaseId) => {
  navigate(`/codebase/edit/${codebaseId}/data-preparation`);
  };

  useEffect(() => {
    const fetchRecentProjects = async () => {
      const userId = sessionStorage.getItem("userId");
      const sessionToken = sessionStorage.getItem("session_token");

      if (!userId || !sessionToken) {
        return;
      }

      try {
        const codebasesData = await codebaseService.getCodebasesForUser(
          userId,
          sessionToken
        );

        if (Array.isArray(codebasesData)) {
          const sortedProjects = [...codebasesData].sort((a, b) => {
            if (!a.updated_at){ return 1};
            if (!b.updated_at) { return -1};

            return new Date(b.updated_at) - new Date(a.updated_at);
          });

          setRecentProjects(sortedProjects.slice(0, 4));
        }

      } catch (error) {
        console.error("Error fetching recent projects:", error);
      }
    };

    fetchRecentProjects();
  }, []);

  return (
    <>
      {/* HERO */}
      <section className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between py-10 px-6 gap-10">
        <div className="max-w-7xl text-center md:text-left space-y-2">
          <p className="inline-flex items-center rounded-full bg-blue-100 px-4 py-1 text-sm font-semibold text-blue-700 mb-6">
            Dashboard
          </p>
          <h1 className="text-5xl font-extrabold leading-tight text-[#0F172A]">
            Welcome back {" "} 
            <span className="text-blue-600">
              {sessionStorage.getItem("userName") || "User"}
            </span>
            ,
          </h1>
          <p className="text-lg text-[#334155]">
            Want to continue your recent project?
          </p>

          {/* RECENT PROJECT CARDS */}
          <div className="mt-6 flex gap-4 overflow-x-auto pb-4">
            {recentProjects.map((project) => (
              <div
                key={project.codebaseId}
                className="min-w-[260px] bg-white rounded-xl border border-[#E2E8F0] shadow-sm overflow-hidden cursor-pointer hover:shadow-md transition"
                onClick={() =>
                  navigate(`/codebase/${project.codebaseId}`)
                }
              >
                <div
                  className="h-32 bg-cover bg-center"
                  style={{
                    backgroundImage:
                      "url(https://images.unsplash.com/photo-1518770660439-4636190af475)",
                  }}
                >
                  <div className="h-full bg-black/50 flex items-end p-4">
                    <h3 className="text-white font-bold text-lg">
                      {project.codebase_name ||
                        `Codebase #${project.codebaseId}`}
                    </h3>
                  </div>
                </div>

                <div className="p-4">
                  <p className="text-sm text-[#64748B] line-clamp-2">
                    {project.codebase_desc ||
                      "Continue this project?"}
                  </p>

                  <button
                  className="mt-4 w-full bg-[#003153] text-white text-xs sm:text-sm font-medium px-3 py-2 rounded-lg hover:bg-[#1D4ED8] hover:text-white transition"
                  onClick={(e) => {
                    e.stopPropagation();
                    EditCodebase(project.codebaseId);
                  }}
                >
                  Edit in Editor
                </button>
                </div>
              </div>
            ))}
          </div>

        <div className="mt-8 p-5 rounded-xl border border-slate-200 bg-white shadow-sm flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start mt-6">
            <button className="bg-[#0EA5E9] text-white font-semibold px-6 py-3 rounded-md hover:bg-[#0284C7] transition">
              <a href="/projects">Try the demo</a>
            </button>
          </div>
        </div>
        </div>
      </section>
    </>
  );
};

export default LandingPage;